import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { fetchCurrentParent } from './actions';
import { withNamespaces } from 'react-i18next';
import * as Routes from './routes';

class Parent extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const { fetchCurrentParent, franchisor, t } = this.props;
		fetchCurrentParent();
		document.title = t('FO_Document_Title', { systemName: franchisor.systemName });
	}

	render() {
		const routes = Routes.ROUTES;

		const { t } = this.props;
		return <div className='franchise-portal'>
			<div className='portal-content'>
				<Switch>
					{routes.map((route, index) => <Route key={index} path={route.path} exact={route.exact} render={props => route.pageTitleResourceKey ? <h2>{t(route.pageTitleResourceKey)}</h2> : null} />)}
				</Switch>
				<Switch>
					{routes.map((route, index) => <Route key={index} path={route.path} exact={route.exact} component={route.mainContent} />)}
				</Switch>
			</div>
		</div>;
	}
}

const mapStateToProps = state => ({
	parent: state.parent,
	franchisor: state.configuration.franchisor
});

export default connect(mapStateToProps, {
	fetchCurrentParent
})(withNamespaces()(Parent));